module.exports = __webpack_public_path__ + "static/media/paicart_logo.5e7c4490.png";